import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { Injectable, inject } from "@angular/core";
import { AvailabilityCode } from "@app/models/rest/availability-code";
import { AvailabilityCodeRestService } from "@app/services/hal/availability-code-rest.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({ providedIn: "root" })
export class AvailabilityCodeStore extends RealTimeDataStore<AvailabilityCode> {
  constructor() {
    const availabilityCodeRestService = inject(AvailabilityCodeRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      availabilityCodeRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("AvailabilityCode");
  }
}
